module.exports = __webpack_public_path__ + "static/media/hangry_.152dc959.bin";